import React, { useState } from 'react'
import { Inertia } from '@inertiajs/inertia'
import Layout from '../../Shared/Layout/LayoutAdmin'
import Row from 'react-bootstrap/Row'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Breadcrumbs from '../../Shared/Components/Breadcrumbs'
import PaginationList from '../../Shared/Components/PaginationList'
import PersonSearch from '../Sia/ProspectLog/PersonSearch'

const Index = ({ entries, users, masters, kinds, filters, coverage }) => {
    const [from, setFrom] = useState(filters.from)
    const [to, setTo] = useState(filters.to)
    const [userId, setUserId] = useState(filters.user_id || '')
    const [kind, setKind] = useState(filters.kind || '')
    const [master, setMaster] = useState(filters.master || '')
    const [policy, setPolicy] = useState(filters.policy || '')
    const [searchText, setSearchText] = useState(filters.search || '')

    function search(event) {
        event.preventDefault()
        Inertia.get(route('consultation-logs.index'), {
            from,
            to,
            user_id: userId,
            kind,
            master,
            policy,
            search: searchText,
        }, { preserveState: true, preserveScroll: true })
    }

    const coverageText = coverage?.from
        ? `Los datos van del ${coverage.from} al ${coverage.to}. Se conservan los últimos 3 meses.`
        : 'Se conservan los últimos 3 meses.'

    return (
        <Row>
            <Breadcrumbs />
            <style>{`
                .log-rows tbody tr:nth-child(even) td { background: #f4f7fb; }
                .log-rows tbody tr:hover td { background: #e4eaf2; }
            `}</style>
            <div className="card card-flush">
                <div className="card-header pt-7">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label fw-bold text-gray-800">Análisis de accesos</span>
                        <span className="text-muted mt-1 fw-semibold fs-7">{coverageText}</span>
                    </h3>
                </div>
                <div className="card-body pt-6">
                    <Form onSubmit={search} className="d-flex flex-wrap gap-3 align-items-end mb-6">
                        <div>
                            <label className="form-label fs-7 fw-bold text-gray-600 mb-2">Desde</label>
                            <Form.Control type="date" value={from} onChange={(event) => setFrom(event.target.value)} />
                        </div>
                        <div>
                            <label className="form-label fs-7 fw-bold text-gray-600 mb-2">Hasta</label>
                            <Form.Control type="date" value={to} onChange={(event) => setTo(event.target.value)} />
                        </div>
                        <div style={{ minWidth: 240 }}>
                            <label className="form-label fs-7 fw-bold text-gray-600 mb-2">Usuario</label>
                            <PersonSearch
                                options={users}
                                value={userId}
                                placeholder="Todos los usuarios"
                                onChange={setUserId}
                            />
                        </div>
                        <div style={{ minWidth: 200 }}>
                            <label className="form-label fs-7 fw-bold text-gray-600 mb-2">Consulta</label>
                            <Form.Select value={kind} onChange={(event) => setKind(event.target.value)}>
                                <option value="">Todas</option>
                                {kinds.map((item) => (
                                    <option key={item.value} value={item.value}>{item.label}</option>
                                ))}
                            </Form.Select>
                        </div>
                        <div style={{ minWidth: 240 }}>
                            <label className="form-label fs-7 fw-bold text-gray-600 mb-2">Maestro</label>
                            <PersonSearch
                                options={masters}
                                value={master}
                                placeholder="Todos los maestros"
                                onChange={setMaster}
                            />
                        </div>
                        <div style={{ minWidth: 160 }}>
                            <label className="form-label fs-7 fw-bold text-gray-600 mb-2">Póliza</label>
                            <Form.Control value={policy} onChange={(event) => setPolicy(event.target.value)} />
                        </div>
                        <div style={{ minWidth: 180 }}>
                            <label className="form-label fs-7 fw-bold text-gray-600 mb-2">Búsqueda</label>
                            <Form.Control value={searchText} onChange={(event) => setSearchText(event.target.value)} />
                        </div>
                        <Button type="submit" size="sm">Buscar</Button>
                    </Form>
                    <div className="table-responsive">
                        <table className="table table-row-dashed align-middle gs-0 gy-3 my-0 log-rows">
                            <thead>
                                <tr className="fs-7 fw-bold text-gray-500 border-bottom-0">
                                    <th>Fecha</th>
                                    <th>Usuario</th>
                                    <th>Consulta</th>
                                    <th>Maestro</th>
                                    <th>Póliza</th>
                                    <th>Búsqueda</th>
                                </tr>
                            </thead>
                            <tbody>
                                {entries.data.length === 0 && (
                                    <tr>
                                        <td colSpan="6" className="text-center text-muted py-6">No hay consultas en este periodo.</td>
                                    </tr>
                                )}
                                {entries.data.map((entry) => (
                                    <tr key={entry.id}>
                                        <td className="text-nowrap">{entry.consulted_at}</td>
                                        <td className="fw-semibold">{entry.user_name}</td>
                                        <td>{entry.kind}</td>
                                        <td>{entry.master_name || '—'}</td>
                                        <td>{entry.policy_number || '—'}</td>
                                        <td>{entry.search_text || '—'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <PaginationList links={entries.links} />
                </div>
            </div>
        </Row>
    )
}

Index.layout = (page) => <Layout children={page} title="Análisis de accesos" />

export default Index
